<template>
  <table class="table table-borderless weddingInfo">
    <tr class="weddingDay">
      <th>挙式日</th>
      <td>{{ business.ceremony_date | formatDateWeekDay | withEmpty }}</td>
    </tr>
    <tr class="weddingStartTime">
      <th>挙式開始</th>
      <td>{{ business.ceremony_start_time | formatTime | withEmpty }}</td>
    </tr>
    <tr class="receptionStartTime">
      <th>披露宴開始</th>
      <td>{{ business.reception_start_time | formatTime | withEmpty }}</td>
    </tr>
    <tr class="weddingVenue">
      <th>会場</th>
      <td>{{ business.banquet_name | withEmpty }}</td>
    </tr>
    <tr class="staffName">
      <th>担当者</th>
      <td>{{ staff.name | withEmpty }}</td>
    </tr>
    <tr class="staffEmail">
      <th>担当者メール</th>
      <td>{{ staff.email | withEmpty }}</td>
    </tr>
  </table>
</template>

<script>
import withEmpty from '@/filters/with-empty'
import formatTime from '@/filters/format-time'
import { formatDateWeekDay } from '@/filters/format-date'

export default {
  props: {
    business: {
      type: Object,
      required: true
    },
    staff: {
      type: Object,
      required: true
    }
  },
  filters: {
    withEmpty,
    formatTime,
    formatDateWeekDay
  },
}
</script>
